import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from '../helpButton/helpButton';
import './title.scss';
import { format, fromUnixTime } from 'date-fns';
import swal from 'sweetalert';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import Icon, { IconType } from '../icon/icon';
import { composeURL } from '../../../utils/urlTools';
const Title = (props) => {
  const {
    children,
    helpText,
    userNavigation,
    myEmail,
    lockIcon
  } = props;

  const handleNavigationClick=(e)=>{
    let user=(e.me?'You':e.email);
    let verb=(e.me?'are':'is');

    let message="";
    let action="";
    let result="";
    if(e.first){
      action="Master";
      result="and can make any modification";
    }
    else{
      action="Reader";
      result="and maybe cannot do any change on the page";
    }
    message=user+" "+verb+" "+action+" "+result;
    let btns={};
    if(e.email==myEmail && e.first==0)
      btns.master={
        text: "Become master",
        value: "master",
      };
    btns.ok=true;
    swal({
      title: user +" " + verb + " "+action,
      text: message,
      buttons: btns    
    }).then((value) => {
      if(value=="master"){
        httpPost("becomemaster",{}).then((res)=>{
        }).catch(error=>{
          console.log("error",error);
        });
      }
    });
  }
  return (
    <div className='title'>
      <div className='title--left'>
        <h2>{children}</h2>
        { (helpText !== '')
          && <HelpButton>{helpText}</HelpButton>}
      </div>
      {userNavigation && <div className='title--right'>
        {userNavigation && typeof(userNavigation)=='object' &&  userNavigation.map((e,index)=>{
          return (<div key={index} className='dot_position'>
            <button 
              type={"button"}
              onClick={()=>{handleNavigationClick(e)}}
              title={(e.first?"Master":"Reader")+"\n"+e.email+"\n"+"Last conn:" + format(new Date(e.updated_at),'H:mm:ss')}
              >
                {e && e.first==1 && lockIcon && 
                  <div className='dot--icon'>
                    <Icon
                      icon={IconType.LOCK}
                      iconSize={'sm'}
                      iconColor={'green'}
                    />
                  </div>}
                <div className={(e.first==1?'dot dot--green':' dot dot--gray')+(e.email==myEmail?" dot--me":"")}>
                  {e.email.substr(0, 3)}
                </div>
              
            </button>
          </div>);
        })}
      </div>}
    </div>
  );
};

Title.propTypes = {
  children: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  userNavigation:PropTypes.array


};

Title.defaultProps = {
  helpText: '',
};

export default Title;
